import { type ProductFormValues, type ProductUpdateValues } from '@/types/product-type';
import { Grid, TextField } from '@mui/material';
import { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import { MySection } from '../../custom/my-section';

interface ProductBasicInformationSectionProps {
  control: Control<ProductFormValues | ProductUpdateValues>;
  register: UseFormRegister<ProductFormValues | ProductUpdateValues>;
  errors: FieldErrors<ProductFormValues | ProductUpdateValues>;
  inline?: boolean;
  onCodeBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export function ProductBasicInformationSection({
  register,
  errors,
  inline,
  onCodeBlur,
}: ProductBasicInformationSectionProps) {
  const content = (
      <Grid container gap={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Product Code"
            placeholder="e.g. SKU-001 (Use For Facebook Sale)"
            InputLabelProps={{ shrink: true }}
            {...register('code' as any, {
              onBlur: onCodeBlur
            })}
            error={!!errors.code}
            helperText={errors.code?.message as string}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Name"
            placeholder="e.g. Premium Hoodie"
            InputLabelProps={{ shrink: true }}
            {...register('name' as any)}
            error={!!errors.name}
            helperText={errors.name?.message as string}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Description"
            placeholder="Describe the product"
            InputLabelProps={{ shrink: true }}
            multiline
            minRows={4}
            {...register('description' as any)}
            error={!!errors.description}
            helperText={errors.description?.message as string}
          />
        </Grid>
      </Grid>
  );

  return inline ? content : (
    <MySection title="Basic information" description="Provide essential product details.">
      {content}
    </MySection>
  );
}
